import { render, staticRenderFns } from "./remove-modal-of-record.html?vue&type=template&id=06459c7b&scoped=true&external"
import script from "./remove-modal-of-record.js?vue&type=script&lang=js&external"
export * from "./remove-modal-of-record.js?vue&type=script&lang=js&external"
import style0 from "./remove-modal-of-record.scss?vue&type=style&index=0&id=06459c7b&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06459c7b",
  null
  
)

export default component.exports